
import VueCharts from "vue-chartjs";
import { Bar, Line, HorizontalBar } from "vue-chartjs";
export default {
  extends: HorizontalBar,
  props: ["ratio"],
  data: () => ({

    chartdata: {
      labels: ['분야1', '분야2', '분야3'],
      datasets: [
        {
          label: '성적',
          backgroundColor: ['#264653', '#2a9d8f', '#e76f51'],
          data: [20, 60, 80]
        }
      ]
    },
    options: {
      responsive: true,
      maintainAspectRatio: false,
      legend: {
        display: false,
      },
      scales: {
        yAxes: [{
          gridLines: {
            display: false,
          },

        }],
        xAxes: [{
          gridLines: {
            display: false,
          },
          ticks: {
            max: 100,
            min: 0,
            stepSize: 10
          }
        }],
        ticks: {
          display: false,
        }
      },

      title: {
        fontFamily: "'Open Sans', sans-serif"
      }

    }
  }),

  mounted() {
    // Overwriting base render method with actual data.
    // console.log(this.ratio)
    this.chartdata.datasets[0].data = this.ratio;
    this.renderChart(this.chartdata, this.options);
  },
};


